import { render, staticRenderFns } from "./SettlementInstructions.vue?vue&type=template&id=dbcd3160&scoped=true&"
import script from "./SettlementInstructions.vue?vue&type=script&lang=js&"
export * from "./SettlementInstructions.vue?vue&type=script&lang=js&"
import style0 from "./SettlementInstructions.vue?vue&type=style&index=0&id=dbcd3160&scoped=true&lang=css&"
import style1 from "./SettlementInstructions.vue?vue&type=style&index=1&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcd3160",
  null
  
)

export default component.exports